import React, { Component } from 'react'
const messageListing = ["Signing you in...", "Iceland is the cleanest country in the world.", "Did you know that 18% of people clean their toilet seat every day?", "A typical home is 200-500% more polluted than the outside air.",
    "The average person has more than 10,000,000 bacteria on their hands.", "The bacteria count of a surface can increase up to 31% per day.", "The average person uses the toilet 2,500 times in 1 year.", "The first motorized vacuum cleaner was invented in 1901 by Hubert Cecil Booth.",
    "Around 50% Of Dust Is Made Up Of Dead Skin Cells.", "The broom was invented in 1797 by American farmer Levi Dickenson, who made the product for his wife.",
    "You Can Use Vodka To Clean Glass & Mirrors.", "The paper towel was invented in 1931 by the Scott Paper Company.", "You Can Clean A Sponge In The Microwave - Microwaving a wet sponge for two minutes will destroy 99% of bacteria and germs on the sponge.",
    "The average work desk is 400 times dirtier than your toilet seat.",
    "Did you know Abco has its own in-house servicing team?", "Abco has over 20,000 m2 of warehouse strategically located Australia wide.",
    "Abco uses our own employed Delivery drivers for all metros areas in Adelaide, Brisbane, Melbourne, Sydney, and Perth.",
    "e-Riteoff (171101) is an Environmentally Friendly, Biodegradable gum, mark, and Graffiti Remover.",
    "Enviroplus solutions have received a platinum health rating, making them the first concentrated, high-performing, safest Australian commercial cleaning products on the market!"];

class SignInLoader extends Component{
    constructor() {
        super();
        this.state = { messageId: 0 };
        this.generateRandom = this.generateRandom.bind(this);
    }
    generateRandom(min, max) {
        var num = Math.floor(Math.random() * (max - min + 1)) + min;
        return (num === this.state.messageId) ? this.generateRandom(min, max) : num;
    }
    componentDidMount() {
        this.timeout = setInterval(() => {
            let currentMessageId = this.state.messageId;
            this.setState({ messageId: this.generateRandom(1, messageListing.length) });
        }, 6000);
    }
    

    componentDidUnmount() {
        clearInterval(this.timeout);
    }

    render() {
        let message = messageListing[this.state.messageId % messageListing.length];

        return (
            <div className='sign-in-loader-container'>
                
                    <div className='loader'>
                        <div className='loader--dot'></div>
                        <div className='loader--dot'></div>
                        <div className='loader--dot'></div>
                        <div className='loader--dot'></div>
                        <div className='loader--dot'></div>
                        <div className='loader--dot'></div>
                    </div>
                
                <div className='loader-text-container'>{ message }</div>
            </div>
        )
    }
}

export default SignInLoader;